import axios from "axios";
require('../axios-config')

export class RoleService {
    static async all() {
        try {
            const {data} = await axios.get(`/api/roles`)
            return data;
        } catch (e) {
            return []
        }
    }
}
